import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import HomeAppBar from "./components/home/header/AppBar";
import { useContext } from "react";
import { AppContext } from "./context/AppContext";
import ScrollToTop from "./components/Common/ScrollToTop";
import CasinoGamesPage from "./components/Pages/Casino/CasinoGamesPage";
import LiveCasino from "./components/Pages/Casino/LiveCasino";
import Roulette from "./components/Pages/Casino/Roulette";
import Slots from "./components/Pages/Casino/Slots";
import SportsGamesPage from "./components/Pages/Casino/SportsGamesPage";
import SportsMain from "./pages/Sports/SportsMain";
import SportsMatch from "./pages/Sports/SportsMatch";
import SportsbookHistoryPage from "./pages/SportsbookHistoryPage";
import "./pages/Sports/sports-theme.css";
import GameLaunchNavigator from "./components/Pages/GamePlayer/GameLaunchNavigator";
import GameMiniPlayer from "./components/Pages/GamePlayer/GameMiniPlayer";
import GamePlayerPage from "./components/Pages/GamePlayer/GamePlayerPage";
import AttendanceCheckPage from "./components/Pages/UserFeatures/AttendanceCheckPage";
import UserFeatureListPage from "./components/Pages/UserFeatures/UserFeatureListPage";
import ProtectedRoute from "./components/Router/ProtectedRoute";
import CashierModal from "./components/Modals/CashierModals/CashierModal";
import SitePopup from "./components/Modals/SitePopup/SitePopup";
import AccountPageLayout from "./components/home/Account/AccountPageLayout";
import Profile from "./components/home/Account/Profile/Profile";
import PageLayout from "./components/home/MainHome/PageLayout";
import {
  ContentLayout,
  SportsContentLayout,
} from "./components/home/MainHome/styles";
import NavBar from "./components/home/header/NavBar/NavBar";
import SideBar from "./components/home/header/SideBar";
import AppRuntimeProviders from "./sportsbook/AppRuntimeProviders";
import SportsbookRuntimeProviders from "./sportsbook/SportsbookRuntimeProviders";
import useAppDeploymentRefresh from "./_hooks/appDeploymentRefresh.hook";
import DynamicSiteMetadata from "./components/DynamicSiteMetadata/DynamicSiteMetadata";

const AppDeploymentRefreshBridge = () => {
  useAppDeploymentRefresh();
  return null;
};

const routesSportsLayout = [
  { path: "/sports", component: SportsMain },
  { path: "/sports/match/:id", component: SportsMatch },
];

const routesContentLayout = [
  { path: "/", component: HomeAppBar },
  { path: "/casino-games", component: CasinoGamesPage },
  { path: "/live-casino", component: LiveCasino },
  { path: "/roulette", component: Roulette },
  { path: "/slots", component: Slots },
  { path: "/sports-games", component: SportsGamesPage },
  { path: "/play", component: GamePlayerPage, protected: true },
  { path: "/event", component: UserFeatureListPage, props: { mode: "events" } },
  {
    path: "/customer-service-center",
    component: UserFeatureListPage,
    props: { mode: "customer" },
  },
  { path: "/notice-board", component: UserFeatureListPage, props: { mode: "notes" } },
  { path: "/attendance-check", component: AttendanceCheckPage },
  { path: "/betting-history", component: SportsbookHistoryPage, protected: true },
];

const routesAccountLayout = [
  { path: "/my-page", component: Profile },
  { path: "/account/profile", component: Profile },
];

function App() {
  const {
    isTabletScreen,
    isAttendanceModalOpen,
    updateAttendanceModal,
    cashierModal,
    closeCashierModal,
  } = useContext(AppContext);

  return (
    <BrowserRouter>
      <AppRuntimeProviders>
        <AppDeploymentRefreshBridge />
        <DynamicSiteMetadata />
        <GameLaunchNavigator />
        <ScrollToTop />
        <NavBar />
        <SideBar />

        <PageLayout>
          <Routes>
            {routesSportsLayout.map((route) => (
              <Route
                key={route.path}
                path={route.path}
                element={
                  <SportsContentLayout
                    className="sportsbook-theme crypto-sportsbook-host sportsbook-route-shell"
                    $isTabletScreen={isTabletScreen}
                  >
                    <SportsbookRuntimeProviders>
                      <route.component />
                    </SportsbookRuntimeProviders>
                  </SportsContentLayout>
                }
              />
            ))}
            <Route path="/international" element={<Navigate to="/sports?type=INTERNATIONAL" replace />} />
            <Route path="/inplay" element={<Navigate to="/sports?type=LIVE" replace />} />
            <Route path="/domestic" element={<Navigate to="/sports?type=DOMESTIC" replace />} />
            <Route path="/sportsbook" element={<Navigate to="/sports?type=DOMESTIC" replace />} />
            <Route path="/my-bets" element={<Navigate to="/betting-history?tab=Sportsbook" replace />} />
            <Route path="/sports/my-bets" element={<Navigate to="/betting-history?tab=Sportsbook" replace />} />
          </Routes>

        <Routes>
          {routesContentLayout.map((route) => {
            const content = <route.component {...(route.props || {})} />;

            return (
              <Route
                key={route.path}
                path={route.path}
                element={
                  <ContentLayout
                    $isTabletScreen={isTabletScreen}
                    $isGamePlayerPage={route.path === "/play"}
                  >
                    {route.protected ? <ProtectedRoute>{content}</ProtectedRoute> : content}
                  </ContentLayout>
                }
              />
            );
          })}
        </Routes>

        <Routes>
          {routesAccountLayout.map((route) => (
            <Route
              key={route.path}
              path={route.path}
              element={
                <ContentLayout $isTabletScreen={isTabletScreen}>
                  <ProtectedRoute>
                    <AccountPageLayout>
                      <route.component />
                    </AccountPageLayout>
                  </ProtectedRoute>
                </ContentLayout>
              }
            />
          ))}
        </Routes>
        </PageLayout>
        {isAttendanceModalOpen ? (
          <AttendanceCheckPage onRequestClose={() => updateAttendanceModal(false)} />
        ) : null}
        <CashierModal
          hideTrigger
          isOpen={cashierModal.isOpen}
          defaultView={cashierModal.view}
          onOpenChange={(nextIsOpen) => {
            if (!nextIsOpen) closeCashierModal();
          }}
        />
        <SitePopup />
        <GameMiniPlayer />
      </AppRuntimeProviders>
    </BrowserRouter>
  );
}

export default App;
